import { fetchConToken } from "../helpers/fetch";

export const checkUserContracts = async (userId) => {
    try {
        const result = await fetchConToken(`contracts/users/${userId}/contracts`, null, "GET");

        if (!result.ok) {
            throw new Error(`Error: ${result.status}`);
        }

        const data = await result.json();
        return data;

    } catch (error) {
        console.error("Error en checkUserContracts:", error);
        throw error;
    }
}
